import "./LoginModal.scss";
import React, { ChangeEvent, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IoCloseCircle, IoEye, IoEyeOff } from "react-icons/io5";
import RestClient from "../../../../@core/restClient";
import { jwtDecode } from "jwt-decode";
import Spinner from "../../../widgets/UI/Spinner";
// interface LoginModalProps {
//   show: boolean;
//   onHide: () => void;
// }

interface LoginData {
  email: string;
  password: string;
}

type LoginDataState = [
  loginData: LoginData,
  setLoginData: (loginData: LoginData) => void
];
const LoginModal = () => {
  const [loginData, setLoginData]: LoginDataState = useState({
    email: "",
    password: ""
  });
  const [registrationModal, setRegistrationModal] = useState(false);
  const [registrationData, setRegistrationData] = useState({
    email: "",
    password: "",
    firstName: "",
    lastName: ""
  });
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [type, setType] = useState(["password", "password"]);
  const [eye, setEye] = useState(["off", "off"]);
  const [isLoading, setIsLoading] = useState(false);
  const [policyCheck, setPolicyCheck] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [codeCheck, setCodeCheck] = useState(false);
  const [codeData, setCodeData] = useState({
    email: "",
    confirmationCode: ""
  });
  const navigate = useNavigate();

  const toggleEye = (i: any) => {
    const types = [...type];
    if (types[i] === "password") {
      types[i] = "text";
    } else {
      types[i] = "password";
    }
    setType(types);

    const eyes = [...eye];
    if (eyes[i] === "off") {
      eyes[i] = "on";
    } else {
      eyes[i] = "off";
    }
    setEye(eyes);
  };
  // ENABLE REGISTRATION BUTTON

  const enable = (e: any) => {
    if (e.target.checked) {
      setPolicyCheck(true);
    } else {
      setPolicyCheck(false);
    }
  };
  useEffect(() => {
    if (
      policyCheck &&
      registrationData.email !== "" &&
      registrationData.password !== "" &&
      registrationData.firstName !== ""
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [policyCheck, registrationData]);

  //LOGI DATA
  const login = async () => {
    try {
      setIsLoading(true);
      const response = await RestClient.login(loginData);
      localStorage.setItem("Token", response.token);
      const decodedToken: any = jwtDecode(response.token);
      localStorage.setItem("User", JSON.stringify(decodedToken));
      navigate(-1);
      //closeModal();
    } catch (error: any) {
      console.log(error.response.data.message);
      setErrorMessage("Непривийльний email або пароль");
      setErrorModal(true);
    }
    setIsLoading(false);
  };

  //SEND REGISTRATION DATA

  const register = async () => {
    try {
      setIsLoading(true);
      const response = await RestClient.register(registrationData);
      if (response?.status === "pending") {
        setCodeCheck(true);
      } else {
        throw "Incorrect response";
      }

      //closeModal();
    } catch (error: any) {
      console.log(error.response.data.message);
      // closeModal();
      //setRegistrationModal(false);
      if (error.response.data.message === "User already exists") {
        setErrorMessage("Користувач з такою адресою вже існує");
      } else {
        setErrorMessage("Щось пішло не так, спробуйте ще раз");
      }
      setErrorModal(true);
    }
    setIsLoading(false);
  };

  const completeRegister = async () => {
    try {
      setIsLoading(true);
      const response = await RestClient.confirmRegistration(codeData);
      if (response?.token) {
        localStorage.setItem("Token", response.token);
        const decodedToken: any = jwtDecode(response.token);
        localStorage.setItem("User", JSON.stringify(decodedToken));
        setRegistrationModal(false);
        setCodeCheck(false);
        navigate(-1);
      } else {
        throw "Incorrect response";
      }
    } catch (error: any) {
      console.log(error.response.data.message);
      // closeModal();
      //setRegistrationModal(false);
      if (error.response.data.message === "Incorrect Confirmation Code") {
        setErrorMessage("Ви ввели неправильний код, спробуйте ще раз");
      } else {
        setErrorMessage("Щось пішло не так, спробуйте ще раз");
      }
      setErrorModal(true);
    }
    setIsLoading(false);
  };

  const openRegistration = () => {
    setRegistrationModal(true);
  };

  const closeRegistration = () => {
    setRegistrationModal(false);
    setRegistrationData({
      email: "",
      password: "",
      firstName: "",
      lastName: ""
    });
    //closeModal();
  };

  return (
    <div className="login-modal">
      {isLoading ? <Spinner /> : ""}
      {!registrationModal ? (
        <div className="login-modal-box">
          <div className="login-input">
            <div className="login-input-item">
              <label htmlFor="">Email</label>
              <input
                type="text"
                placeholder="Введіть email"
                value={loginData.email}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  setLoginData({ ...loginData, email: event.target.value })
                }
              />
            </div>
            <div className="login-input-item">
              <label htmlFor="">Пароль</label>
              <input
                type={type[0]}
                placeholder="Введіть пароль"
                value={loginData.password}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  setLoginData({ ...loginData, password: event.target.value })
                }
              />
              <div className="login-input-item-eye">
                {type[0] === "password" ? (
                  <IoEye onClick={() => toggleEye(0)} />
                ) : (
                  <IoEyeOff onClick={() => toggleEye(0)} />
                )}
              </div>
            </div>
          </div>
          <div className="btn-box">
            <button className="btn-mcolor btn-box-btn" onClick={login}>
              Увійти
            </button>
            <button
              className="btn-forget-password"
              onClick={() => {
                setErrorModal(true);
                setErrorMessage(
                  "Якщо ви забули пароль, напишіть у підтримку, ми допоможемо вам зайти у додаток та відновити пароль. Контактна інформація є у футері сайту."
                );
              }}
            >
              Забули пароль?
            </button>
          </div>
          <div className="invite">
            <p className="invite-text">
              Якщо ви не зареєстровані, тисніть{" "}
              <button
                className="btn-plain invite-text-btn"
                onClick={openRegistration}
              >
                Сюди
              </button>{" "}
            </p>
          </div>
          <IoCloseCircle className="closeIcon" onClick={() => navigate(-1)} />

          {errorModal ? (
            <div className="error-box">
              <p className="error-text">{errorMessage}</p>
              <IoCloseCircle
                className="closeIcon"
                onClick={() => setErrorModal(false)}
              />
            </div>
          ) : null}
        </div>
      ) : (
        <div className="login-modal-box">
          <div className="login-input">
            <div className="login-input-item">
              <label htmlFor="">Ім&apos;я</label>
              <input
                type="text"
                //placeholder="Ім'я"
                value={registrationData.firstName}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  setRegistrationData({
                    ...registrationData,
                    firstName: event.target.value
                  })
                }
              />
            </div>
            <div className="login-input-item">
              <label htmlFor="">Прізвище</label>
              <input
                type="text"
                //placeholder="Прізвище"
                value={registrationData.lastName}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  setRegistrationData({
                    ...registrationData,
                    lastName: event.target.value
                  })
                }
              />
            </div>
          </div>

          <div className="login-input">
            <div className="login-input-item">
              <label htmlFor="">Email</label>
              <input
                type="text"
                //placeholder="Email"
                value={registrationData.email}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                  setRegistrationData({
                    ...registrationData,
                    email: event.target.value
                  });
                  setCodeData({
                    ...codeData,
                    email: event.target.value
                  });
                }}
              />
            </div>
            <div className="login-input-item">
              <label htmlFor="">Пароль</label>
              <input
                type={type[1]}
                //placeholder="Пароль"
                value={registrationData.password}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  setRegistrationData({
                    ...registrationData,
                    password: event.target.value
                  })
                }
              />
              <div className="login-input-item-eye">
                {type[1] === "password" ? (
                  <IoEye onClick={() => toggleEye(1)} />
                ) : (
                  <IoEyeOff onClick={() => toggleEye(1)} />
                )}
              </div>
            </div>
          </div>
          <div className="policy">
            <input type="checkbox" id="policy" onClick={(e) => enable(e)} />
            <label
              htmlFor="policy"
              onClick={() => navigate("/privacypolicyukr")}
            >
              З політикою конфіденційності сайту ознайомлений
            </label>
          </div>
          <div className="btn-box">
            <button
              className={
                disabled
                  ? "btn-mcolor-inactive btn-box-btn"
                  : "btn-mcolor btn-box-btn"
              }
              onClick={register}
              disabled={disabled}
            >
              Зареєструватись
            </button>
          </div>

          <IoCloseCircle className="closeIcon" onClick={closeRegistration} />
          {codeCheck ? (
            <div className="codecheck-box">
              <div>
                <p className="codecheck-box-message">
                  Ми відправили вам на електронну пошту листа з кодом. Для
                  завершення реєстрації введіть цей код у поле знизу. Якщо ліст
                  не надійшов, перевірте адресу і почніть реєстрацію спочатку.
                </p>
                <input
                  type="text"
                  className="login-input"
                  value={codeData.confirmationCode}
                  onChange={(event: ChangeEvent<HTMLInputElement>) =>
                    setCodeData({
                      ...codeData,
                      confirmationCode: event.target.value
                    })
                  }
                />
              </div>
              <div>
                <button className="btn-mcolor" onClick={completeRegister}>
                  Відправити
                </button>
              </div>
            </div>
          ) : null}
          {errorModal ? (
            <div className="error-box">
              <p className="error-text">{errorMessage}</p>
              <IoCloseCircle
                className="closeIcon"
                onClick={() => {
                  setErrorModal(false);
                  navigate(-2);
                }}
              />
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};
export default LoginModal;
